import type { PropsWithChildren } from 'react';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';

import { Card } from '@/components/ui/card';
import { AlertStatus } from '@/entities/alert-status';

import { Disclosure, DisclosurePanel, DisclosureTitle } from '../disclosure';

HC_more(Highcharts);

export type PlotSectionProps = PropsWithChildren<{
  sectionName: string;
  sectionStatus?: AlertStatus; // Active status when data present
  inactive?: boolean; // No data → grey dot
}>;
export function PlotSection({
  children,
  sectionStatus,
  inactive = false,
  sectionName,
}: PlotSectionProps) {
  return (
    <Disclosure className="w-full">
      {({ open }: { open: boolean }) => (
        <>
          <DisclosureTitle status={sectionStatus} inactive={inactive}>
            <span>{sectionName}</span>
          </DisclosureTitle>
          {open && (
            <DisclosurePanel className="w-full">
              <dl className="flex h-auto flex-col items-start justify-start self-stretch p-4">
                <Card className="w-full">{children}</Card>
              </dl>
            </DisclosurePanel>
          )}
        </>
      )}
    </Disclosure>
  );
}
